"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getButtonUtilityClass = getButtonUtilityClass;
var _base = require("@ori-ui/mui-bundle/base");
function getButtonUtilityClass(slot) {
  return (0, _base.generateUtilityClass)('MuiOriButton', slot);
}
const buttonClasses = (0, _base.generateUtilityClasses)('MuiOriButton', ['colorDefault', 'colorError', 'colorInherit', 'colorPrimary', 'contained', 'disabled', 'endIcon', 'focusVisible', 'fullWidth', 'icon', 'iconSizeMedium', 'iconSizeSmall', 'loading', 'loadingIconPlaceholder', 'loadingIndicator', 'loadingPositionCenter', 'loadingPositionEnd', 'loadingPositionStart', 'loadingWrapper', 'outlined', 'root', 'sizeMedium', 'sizeSmall', 'startIcon', 'text']);
var _default = exports.default = buttonClasses;
//# sourceMappingURL=buttonClasses.js.map